// NPM Imports
import React, { Component } from "react";
// import { connect } from "react-redux";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import AssetItem from "../AssetItem";

// Actions Imports

// Internal Imports
// import { ASSET } from "../../../../constants";

// Destructuring
// const { ASSET_ITEMS } = ASSET;

class AssetItems extends Component {
  state = {};

  render() {
    const {
      assetItems,
      selectAssetItem,
      isAnyItemSelected,
      toggleActionDropdown,
      selectedCheckboxItems,
      isAllAssetItemsSelected,
      assetColumns,
      showSearchPage,
    } = this.props;
    return (
      <div className="assetitems-container">
        {assetItems.map((assetItem, index) => (
          <AssetItem
            key={assetItem}
            index={index}
            assetItemId={assetItem}
            selectAssetItem={selectAssetItem}
            isAnyItemSelected={isAnyItemSelected}
            isAllAssetItemsSelected={isAllAssetItemsSelected}
            toggleActionDropdown={toggleActionDropdown}
            selectedCheckboxItems={selectedCheckboxItems}
            assetColumns={assetColumns}
            history={this.props.history}
            showSearchPage={showSearchPage}
          />
        ))}
      </div>
    );
  }
}

export default AssetItems;



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/AssetItems/index.js